import React from 'react';
import { Text } from '@fragments';
import './styles.scss';

// What a one-click upgrade charges, as `GET /subscription/preview` computed it: the time
// left on the current plan comes off today's charge, and the new plan's full price renews
// on `renews_at`. Today's total is the pay button below it. Skeleton rows hold the height
// while the preview loads.
export default function UpgradeReceipt({ preview, current, money, date, t }) {
  if (!preview) {
    return <div className="studio-upgrade-receipt is-loading" aria-hidden="true">
      {[0, 1].map(row => <div key={row} className="studio-upgrade-receipt__row">
        <Text.span contrast={7} loading>{t('planPreviewLoading')}</Text.span>
        <Text.span contrast={9} loading>R$ 000,00</Text.span>
      </div>)}
    </div>;
  }
  return <dl className="studio-upgrade-receipt">
    {preview.credit > 0 && <div className="studio-upgrade-receipt__row">
      <dt><Text.span contrast={7}>{t('planUpgradeCredit', { plan: t(`planShort_${current}`) })}</Text.span></dt>
      <dd><Text.span contrast={9}>{`−${money(preview.credit)}`}</Text.span></dd>
    </div>}
    <div className="studio-upgrade-receipt__row">
      <dt><Text.span contrast={7}>{preview.renews_at ? t('planUpgradeNextCharge', { date: date(preview.renews_at) }) : t('planUpgradeThen')}</Text.span></dt>
      <dd><Text.span contrast={9}>{money(preview.amount)}</Text.span></dd>
    </div>
  </dl>;
}
